export default "__VITE_ASSET__DLhwLkFs__"